export default __webpack_public_path__ + "static/media/4th_two_page_birth_certificate.d3abd4de.jpg";